import { formatLabel } from "../../helpers/decisionNarrativeHelpers";
import { SectionHeading } from "./NarrativePresentation";

export const CurrentProtectionBaseline = ({ protections }) => (
  <section aria-labelledby="current-protection-title" className="rounded-2xl border border-sky-200 bg-sky-50/40 p-6 shadow-sm">
    <SectionHeading eyebrow="What already protects the organization?" title="Current Protection Baseline" id="current-protection-title" description="Existing protection already implemented or committed across the portfolio." />
    <div className="mt-5 rounded-xl border border-sky-200 bg-white p-4 text-sm leading-6 text-slate-700">
      <p>Current portfolio recommendations are evaluated after considering the organisation&apos;s existing protection mechanisms.</p>
      <p className="mt-3 font-semibold text-slate-950">The optimisation recognises:</p>
      <ul className="mt-2 list-disc space-y-1 pl-5">
        <li>Active cyber insurance coverage</li>
        <li>Existing mitigation controls</li>
        <li>Financial risk transfer</li>
        <li>Current retained exposure</li>
      </ul>
      <p className="mt-3">Investment recommendations are therefore based on the organisation&apos;s residual portfolio exposure, rather than its original gross cyber risk.</p>
    </div>
    {protections.length ? (
      <ul className="mt-5 grid gap-3 lg:grid-cols-2">
        {protections.map((item, index) => <li key={item?.id || index} className="rounded-xl border border-sky-200 bg-white p-4"><p className="font-semibold text-slate-950">{item?.name || formatLabel(item?.category) || `Existing protection ${index + 1}`}</p>{item?.status && <p className="mt-1 text-xs font-semibold uppercase text-sky-700">{formatLabel(item.status)}</p>}{item?.description && <p className="mt-2 text-sm text-slate-600">{item.description}</p>}</li>)}
      </ul>
    ) : null}
  </section>
);
